import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { allPatriotsUserList } from '../../Redux/actions/homeAction';
import { getToken } from '../../Helper/Session';
import { toast } from 'react-toastify';
import InfiniteScroll from "react-infinite-scroll-component";
import { db, storage } from "../Services/firebase";
import $ from 'jquery';
import { v4 as uuidv4 } from 'uuid';
import { isEmpty } from "../../Helper/Util";
import { Loader } from '../Common/Loader';
import { addNewChat, getMyChats } from '../../Redux/actions/chatAction';

class UsersToChat extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search: '',
            errors: {},
            page: 1,
            users: [],
            title: '',
            url: null
        }
    }

    componentDidMount() {
        let token = getToken() !== null ? JSON.parse(getToken()) : '';
        this.setState({
            users: [...this.state.users, token]
        });
        const params = {
            apikey: process.env.REACT_APP_API_KEY,
            page: this.state.page,
            search: this.state.search ? this.state.search : ''
        }
        this.props.allPatriotsUserList(params);
        this.props.getMyChats(token.id);
    }

    fetchMoreData = () => {
        let newPage = this.state.page;
        newPage++;
        if (this.props.home.pgCurrentPage !== this.state.page) {
            newPage = this.props.home.pgCurrentPage + 1
        }
        this.setState({ page: newPage });
        const params = {
            apikey: process.env.REACT_APP_API_KEY,
            page: newPage,
            search: this.state.search ? this.state.search : ''
        }
        this.props.allPatriotsUserList(params)
    };

    searchKeyword = (e) => {
        this.setState({
            search: e.target.value,
            page: 1
        });
        const params = {
            apikey: process.env.REACT_APP_API_KEY,
            page: e.target.value !== '' ? this.state.page : 1,
            search: e.target.value
        }
        this.props.allPatriotsUserList(params)
    }

    handleChange = e => {
        this.setState({
            ...this.state,
            [e.target.name]: e.target.value,
            errors: {
                ...this.state.errors,
                [e.target.name]: ''
            }
        })
    }

    handleImgChange = (e) => {
        this.setState({
            url: e.target.files[0],
            errors: {
                url: ''
            }
        });
    };

    toggleCheckboxChange = (e, s) => {
        let users = this.state.users
        if (e.target.checked) {
            users.push(s)
        } else {
            const index = this.state.users.indexOf(s);
            if (index > -1) {
                this.state.users.splice(index, 1);
            }
        }
        this.setState({
            users
        })
    }

    validate = () => {
        const { users } = this.state;
        let errors = {};
        if (users.length === 1) errors.users = toast.error('Select atleast One User', {
            position: toast.POSITION.TOP_RIGHT
        });
        return errors;
    }

    validateGrp = () => {
        const { title } = this.state;
        let errors = {};
        if (isEmpty(title)) errors.title = true;
        return errors;
    }

    handleSubmit = (e) => {
        e.preventDefault()
        const errors = this.validate();
        if (Object.keys(errors).length !== 0) {
            this.setState({ errors });
            return false;
        }
        if (this.state.users.length > 2) {
            $('#grpChat').modal('show');
            return false;
        }
        let token = getToken() !== null ? JSON.parse(getToken()) : '';
        let authUser = token.id;
        let users = this.state.users;
        let userObj = {};
        let unreadObj = {};
        for (let i = 0; i < users.length; i++) {
            userObj[users[i].id] = users[i].id;
            unreadObj['unread' + users[i].id] = 0;
        }
        const { chat: { myChats } } = this.props;
        let myRef = db.ref().push();
        const params = {
            authUser: authUser,
            id: myRef.key,
            title: '',
            url: '',
            unreadObj: 0,
            users: userObj
        }
        if (myChats.length > 0) {
            for (let i = 0; i < myChats.length; i++) {
                if (JSON.stringify(myChats[i].users) === JSON.stringify(userObj) && myChats[i].url === '') {
                    this.props.history.push(`chat-${myChats[i].id}`);
                    localStorage.setItem('chatDetail', JSON.stringify(myChats[i]));
                    return false
                }
            }
            this.props.addNewChat(params, users);
            this.props.history.push(`chat-${myRef.key}`);
        } else {
            this.props.addNewChat(params, users);
            this.props.history.push(`chat-${myRef.key}`);
        }
    }

    handleGroupSubmit = (e) => {
        e.preventDefault();
        const errors = this.validateGrp();
        if (Object.keys(errors).length !== 0) {
            this.setState({ errors });
            return false;
        }
        let token = getToken() !== null ? JSON.parse(getToken()) : '';
        let chatImg = this.state.url;
        let storageRef = storage.ref();
        let users = this.state.users;
        let userObj = {};
        let unreadObj = {};
        let authUser = token.id;
        let title = this.state.users.length > 2 ? this.state.title : '';
        let imageUrl = '';
        if (chatImg !== null) {
            let encodedImg = chatImg.name.split('.')[0] + '_' + Date.now() + '.' + chatImg.name.split('.')[1];
            let imageRef = storageRef.child("ChatImages/" + encodedImg);
            imageRef.put(chatImg)
                .then((res) => {
                });
            imageUrl = "https://firebasestorage.googleapis.com/v0/b/got-your-6.appspot.com/o/ChatImages" + encodeURIComponent('/' + encodedImg) + "?alt=media&token=" + uuidv4();
        }
        for (let i = 0; i < users.length; i++) {
            userObj[users[i].id] = users[i].id;
            unreadObj['unread' + users[i].id] = 0;
        }
        const { chat: { myChats } } = this.props;
        let myRef = db.ref().push();
        const params = {
            authUser: authUser,
            id: myRef.key,
            title: title,
            url: imageUrl,
            unreadObj: 0,
            users: userObj
        }
        if (myChats.length > 0) {
            for (let i = 0; i < myChats.length; i++) {
                if (JSON.stringify(myChats[i].users) === JSON.stringify(userObj) && myChats[i].title === title) {
                    $('#grpChat').modal('hide');
                    this.props.history.push(`chat-${myChats[i].id}`);
                    localStorage.setItem('chatDetail', JSON.stringify(myChats[i]));
                    return false
                }
            }
            this.props.addNewChat(params, users);
            this.props.history.push(`chat-${myRef.key}`)
        } else {
            this.props.addNewChat(params, users);
            this.props.history.push(`chat-${myRef.key}`)
        }
        $('#grpChat').modal('hide');
    }

    render() {
        let token = getToken() !== null ? JSON.parse(getToken()) : '';
        const { home: { patriotUsers, patriotUsersHasMore, pgCurrentPage } } = this.props;
        const { errors } = this.state;
        let markup = patriotUsers.length > 0 ? patriotUsers.map((result, i) => {
            if (result.id !== token.id) {
                return (
                    <li key={i}>
                        <div className="userProfile">
                            <figure>
                                <img src={result.url !== '' ? process.env.REACT_APP_API_URL + result.url : '../images/logo.png'} alt="User" />
                            </figure>
                            <figcaption>
                                <h2>{result.name} @<span>{result.username}</span></h2>
                                <p><i className="location"></i>{result.city}, {result.state}</p>
                            </figcaption>
                        </div>
                        <div className={this.state.users.length > 0 && this.state.users.includes(result) === true ? 'userAddIcon added' : 'userAddIcon'}>
                            <input
                                type="checkbox"
                                className='form-control'
                                id={result.id}
                                value={result.id}
                                checked={this.state.users.find((u) => u.id === result.id)}
                                onChange={(e) => this.toggleCheckboxChange(e, result)}
                            />
                        </div>
                    </li >
                )
            }
        }) : (pgCurrentPage === 1 ? <p className="no-data">No Data</p> : '');
        return (
            <section className="main-Section">
                <header className="header">
                    <div className="container-fluid">
                        <div className="header-section">
                            <Link to="chat">
                                <img src="../images/back.svg" alt="Back" />
                            </Link>
                            <h2 className="page-title">User List</h2>
                            <button type="button" className="saveBtn" onClick={(e) => this.handleSubmit(e)}>Next</button>
                        </div>
                    </div>
                </header>
                <div className="container-fluid midSection" style={{ height: "auto" }}>
                    <div className="content">
                        <div className="search-box">
                            <input type="text" placeholder="Search" value={this.state.search} name="search" onChange={this.searchKeyword} className="inp" />
                        </div>
                    </div>
                    <div className="content">
                        <div className="usersList">
                            <InfiniteScroll
                                dataLength={patriotUsers.length}
                                next={this.fetchMoreData}
                                hasMore={patriotUsersHasMore}
                                loader={patriotUsers.length >= 10 ? <Loader /> : ''}
                            >
                                <ul>
                                    {markup}
                                    {pgCurrentPage === 0 ? <Loader /> : ''}
                                </ul>
                            </InfiniteScroll>
                        </div>
                    </div>
                </div>
                <div className="modal custom-modal initiateFreedom fade" id="grpChat" aria-labelledby="exampleModalLabel" aria-modal="true" role="dialog">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body p-0 pt-4">
                                <div className="logo"><img src="../images/logo.png" alt="Logo" /></div>
                                <form onSubmit={this.handleGroupSubmit}>
                                    <div className="grpchat-text-block">
                                        <fieldset className="mb-10">
                                            <input type="text" placeholder="Title" name="title" className={`form-control ${errors.title ? 'inputError' : ''}`} value={this.state.title} onChange={this.handleChange} />
                                        </fieldset>
                                        <input type="file" name="url" className={`form-control`} onChange={this.handleImgChange} />
                                    </div>
                                    <div className="yesNoBtns">
                                        <button type="button" className="btn saveBtn" onClick={(e) => this.handleGroupSubmit(e)}>Create</button>
                                        <button className="btn" data-dismiss="modal">Cancel</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

const mapStateToProps = (state) => ({
    home: state.home,
    chat: state.chat,
    UI: state.UI
})

const mapActionToProps = {
    allPatriotsUserList,
    addNewChat,
    getMyChats
}

export default connect(mapStateToProps, mapActionToProps)(withRouter(UsersToChat));